export default __webpack_public_path__ + "static/symple-553a6ae0825979b513a77945aecc9e83.jpg";